/* eslint-disable react/prop-types, react/jsx-handler-names */

import Chip from '@material-ui/core/Chip';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import { emphasize } from '@material-ui/core/styles/colorManipulator';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import CancelIcon from '@material-ui/icons/Cancel';
import classNames from 'classnames';
import React from 'react';
import Select from 'react-select';
import UserAvatar from './userAvatar';

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  input: {
    display: 'flex',
    cursor: 'default',
    borderColor: '#eee',
    padding: 0,
    minHeight: '56px',
    height: 'auto',
  },
  error: {
    border: 'solid 2px red'
  },
  valueContainer: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    overflowY: 'hidden',
    overflowX: 'auto',
    padding: theme.spacing(1, 2),
    cursor: 'text',
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1, 0.25),
    },
  },
  chip: {
    margin: theme.spacing(0.5, 0.25),
  },
  chipFocused: {
    backgroundColor: emphasize(
      theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
      0.08,
    ),
  },
  noOptionsMessage: {
    padding: theme.spacing(1, 2),
  },
  singleValue: {
    fontSize: 14,
    fontFamily: theme.typography.fontFamily,
    display: 'flex',
    '&.disabled': {
      color: 'rgba(0, 0, 0, 0.38)'
    }
  },
  placeholder: {
    position: 'absolute',
    left: 20,
    fontSize: 14,
    fontFamily: theme.typography.fontFamily
  },
  paper: {
    position: 'absolute',
    marginTop: 0,
    marginBottom: '30px',
    left: 0,
    zIndex: 9999,
    right: 0,
  },
  divider: {
    height: theme.spacing(2)
  },
});

function NoOptionsMessage(props) {
  if (props.selectProps.noOptionsCTA && props.selectProps.noOptions && props.selectProps.inputValue.indexOf('@') > 0) {
    return <div style={{textDecoration: 'underline', cursor: 'pointer', padding: '8px 16px'}} onClick={() => props.selectProps.noOptionsCTA(props.selectProps.inputValue)}>
      {props.selectProps.noOptions}
    </div>
  }
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.noOptionsMessage}
      {...props.innerProps}
    >
      {props.selectProps.noOptions || props.children}
    </Typography>
  );
}

function inputComponent({ inputRef, ...props }) {
  return <div ref={inputRef} {...props} />;
}

function Control(props) {

  return (
    <TextField
      fullWidth
      margin="none"
      variant="outlined"
      InputProps={{
        inputComponent,
        inputProps: {
          className: classNames(
            props.selectProps.classes.input,
            {[props.selectProps.classes.error]: props.selectProps.TextFieldProps.haserror === 'true'}
          ),
          inputRef: props.innerRef,
          children: props.children,
          ...props.innerProps,
        },
      }}
      InputLabelProps={{
        shrink: props.menuIsOpen || props.hasValue || props.isFocused,
      }}
      {...props.selectProps.TextFieldProps}
    />
  );
}

function Option(props) {
  const label = props.data.label || ''
  const logo = props.data.logo || ''
  const isUser = props.data.value && (props.data.value.indexOf('@') >= 0 || props.data.value === 'guests')
  return (
    <MenuItem
      buttonRef={props.innerRef}
      selected={props.isFocused}
      component="div"
      style={{
        fontSize: '12px',
        minHeight: 36,
        display: 'flex',
        fontWeight: 'normal !important',
      }}
      {...props.innerProps}
    >
      <div style={{marginRight: 8}}><UserAvatar profileImage={logo} width={24} isClub={!isUser} /></div>
      <div>{label}</div>
    </MenuItem>
  );
}

function Placeholder(props) {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.placeholder}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function SingleValue(props) {
  const label = props.data.label || ''
  const logo = props.data.logo || ''
  const isUser = props.data.value.indexOf('@') >= 0
  return (
    <Typography
      component='span'
      className={classNames(
        props.selectProps.classes.singleValue,
        {'disabled': props.isDisabled}
        )}
      {...props.innerProps}>
      <div style={{marginRight: 8}}><UserAvatar profileImage={logo} width={24} isClub={!isUser} /></div>
      <div>{label}</div>
    </Typography>
  );
}

function ValueContainer(props) {  
  return <div className={props.selectProps.classes.valueContainer} style={props.isMulti ? {flexWrap: 'wrap'} : {}}>{props.children}</div>;
}

function MultiValue(props) {  
  return (
    <Chip
      key={props.index}
      tabIndex={-1}
      avatar={props.data && props.data.value && <UserAvatar profileImage={props.data.logo} isClub={props.data.value.indexOf('@') < 0} width={24} styles={{marginLeft: 8}} />}
      label={props.children}
      className={classNames(props.selectProps.classes.chip, {
        [props.selectProps.classes.chipFocused]: props.isFocused,
      })}
      onDelete={props.removeProps.onClick}
      deleteIcon={<CancelIcon {...props.removeProps} />}
    />
  );
}

function Menu(props) {
  return (
    <Paper id="paper-menu" square className={props.selectProps.classes.paper} {...props.innerProps}>
      {props.children}
    </Paper>
  );
}

const components = {
  Control,
  Menu,
  MultiValue,
  NoOptionsMessage,
  Option,
  Placeholder,
  SingleValue,
  ValueContainer,
};
class AutofillSelect extends React.Component {
  render() {
    const { classes, theme } = this.props;
    const selectStyles = {
      input: base => ({
        ...base,
        color: theme.palette.primary.dark,
        '& input': {
          font: 'inherit'
        },
      }),
    };

    return (
      <div className={classes.root} style={{...this.props.rootStyle}}>
          <Select
            classes={classes}
            styles={selectStyles}
            name={this.props.name || ''}
            TextFieldProps={this.props.textFieldProps || {}}
            options={this.props.options}
            components={components}
            menuPortalTarget={this.props.menuPortalTarget || ''}
            value={this.props.selectedValue}
            isClearable={true}
            isSearchable={true}
            isDisabled={this.props.disabled}
            onFocus={this.props.handleAutoSelectTextChange ? this.props.handleAutoSelectTextChange() : null}
            onInputChange={this.props.handleAutoSelectTextChange ? this.props.handleAutoSelectTextChange() : null}
            onChange={this.props.handleAutoSelectChange ? this.props.handleAutoSelectChange(this.props.name) : null}
            placeholder={this.props.placeholder || ''}
            noOptions={this.props.noOptions || ''}
            noOptionsCTA={this.props.noOptionsCTA}
            isMulti={this.props.isMulti}
          />
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(AutofillSelect);
